var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.children
    ? _c(
        "el-submenu",
        { attrs: { index: _vm.list[_vm.keyField] } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { class: _vm.list.ICON }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.list[_vm.titleField]))]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.list.children, function (list) {
            return [
              _c("dg-sub-menu", {
                attrs: {
                  list: list,
                  "key-field": _vm.keyField,
                  "pkey-field": _vm.pkeyField,
                  "title-field": _vm.titleField,
                  "route-field": _vm.routeField,
                },
              }),
            ]
          }),
        ],
        2
      )
    : _c("el-menu-item", { attrs: { index: _vm.list[_vm.keyField] } }, [
        _c("i", { class: _vm.list.ICON }),
        _c("span", { attrs: { slot: "title" }, slot: "title" }, [
          _vm._v(_vm._s(_vm.list[_vm.titleField])),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }